/**
 * 
 * Get the Help Page urls for pages hosted in Google Sites, or elsewhere to be embedded in iframe
 * For future todo: move to database entries, with admin tables for updating.
 */
const REACT_APP_FAQ_ENGLISH="https://help.buddydance.com/english";//process.env.REACT_APP_FAQ_ENGLISH; // || "https://sites.google.com/view/dance4healing-help/home";
const REACT_APP_FAQ_SPANISH="https://help.buddydance.com/español";//process.env.REACT_APP_FAQ_SPANISH; // || "https://sites.google.com/view/dance4healing-help/home";
const REACT_APP_FAQ_CHINESE="https://help.buddydance.com/中文";//process.env.REACT_APP_FAQ_CHINESE; // || "https://sites.google.com/view/dance4healing-help/home";

const REACT_APP_VIDEO_TUTORIAL_ENGLISH="https://help.buddydance.com/tutorial"; //process.env.REACT_APP_VIDEO_TUTORIAL_ENGLISH// || "https://sites.google.com/view/dance4healing-help/tutorial";
const REACT_APP_VIDEO_TUTORIAL_SPANISH="https://help.buddydance.com/tutorial"; //process.env.REACT_APP_VIDEO_TUTORIAL_SPANISH// || "https://sites.google.com/view/dance4healing-help/tutorial";
const REACT_APP_VIDEO_TUTORIAL_CHINESE="https://help.buddydance.com/tutorial"; //process.env.REACT_APP_VIDEO_TUTORIAL_CHINESE// || "https://sites.google.com/view/dance4healing-help/tutorial";



function getHelpDocsbyLanguage(language) {
    let faqPath = REACT_APP_FAQ_ENGLISH;
    let videoTutorialPath = REACT_APP_VIDEO_TUTORIAL_ENGLISH;
    if (language == "en-US" || language == "en-GB" || /^en/i.test(language)) {
      faqPath = REACT_APP_FAQ_ENGLISH;
      videoTutorialPath = REACT_APP_VIDEO_TUTORIAL_ENGLISH;
    } else if (language == "cn" || /^cn/i.test(language) || /^zh/i.test(language)) {
      faqPath = REACT_APP_FAQ_CHINESE;
      videoTutorialPath = REACT_APP_VIDEO_TUTORIAL_CHINESE;
    } else if (/^es/i.test(language)) {
      faqPath = REACT_APP_FAQ_SPANISH;
      videoTutorialPath = REACT_APP_VIDEO_TUTORIAL_SPANISH;
    }
    return { faqPath, videoTutorialPath };
  }
  
export {
    REACT_APP_FAQ_ENGLISH,
    REACT_APP_FAQ_SPANISH,
    REACT_APP_FAQ_CHINESE,
    REACT_APP_VIDEO_TUTORIAL_ENGLISH,
    REACT_APP_VIDEO_TUTORIAL_SPANISH,
    REACT_APP_VIDEO_TUTORIAL_CHINESE,
    getHelpDocsbyLanguage
}


